/**
 * 참고 : https://github.kakaocorp.com/kakaopage/karina/blob/f8906dc84d55685eab614d8ac339684ec5b4055e/modules/karina-core/src/main/kotlin/com/kakaopage/karina/model/enums/ScreenType.kt#L8-L8
 */
export enum SubtabTypeVo {
  Home = 'HOME',
  Special = 'SPECIAL',
  Section = 'SECTION',
  Landing = 'LANDING',
}
